import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import {
  callUseTicket,
  getTicketDetailById,
} from "../../services/game.service";
import ScratchCard from "react-scratchcard-v2";
import html2canvas from "html2canvas";
import safeHtml2canvas from "../../utils/safeHtml2canvas";
import CardGameItem from "../items/CardGameItem";
// import { rewardToken } from "../../helpers/sweetalertToken";

interface PopUpUseTicketL4Props {
  open: boolean;
  ticketId: string;
  onClose: () => void;
  callbackData: (response: any) => void;
}

export default function PopUpUseTicketL4({
  open,
  ticketId,
  onClose,
  callbackData,
}: PopUpUseTicketL4Props) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);
  const [imageScratch, setImageScratch] = useState<string>("");
  const [resultData, setResultData] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (divRef.current && open) {
        try {
          const dataUrl = await safeHtml2canvas(divRef.current, {
            scale: 2,
            backgroundColor: null,
          });
          if (!cancelled) setImageScratch(dataUrl || "");
          if (!dataUrl)
            console.warn(
              "PopUpUseTicketL4: html2canvas returned null (fallback)"
            );
        } catch (err) {
          console.warn("PopUpUseTicketL4: html2canvas failed", err);
          if (!cancelled) setImageScratch("");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open, ticketId]);

  useEffect(() => {
    if (resultData && !imageScratch) {
      const t = setTimeout(() => {
        callbackData(resultData);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [resultData, imageScratch, callbackData]);

  const onSubmit = async () => {
    // test >>>>>>>>
    // rewardToken(50);
    // return;
    // test <<<<<<<<

    setLoading(true);
    try {
      // callUseTicket() reads token from sessionStorage if not provided
      const response = await callUseTicket({ ticketId });
      console.log("response:::", response);
      setResultData(response);
    } catch (error) {
      // errorAdd("ຊື້ບໍ່ສຳເລັດ"); // ถ้ามี sweetalert
      onClose();
    } finally {
      setLoading(false);
    }
  };
  // console.log("ticketId::", ticketId);
  const { data: ticketDetail, isLoading } = useQuery(
    ["get-ticket-detail", ticketId],
    async () => {
      // getTicketDetailById() will read token from sessionStorage if not provided
      return await getTicketDetailById({ ticketId: ticketId as string });
    },
    {
      enabled: !!ticketId,
    }
  );

  if (isLoading) {
    return null;
  }

  return (
    <>
      {/* Hidden div to convert to image */}
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
        <div
          ref={divRef}
          className="bg-[#D65072] w-[120px] h-[120px] text-white text-[50px] font-bold flex justify-center items-center rounded-[10px]"
        ></div>
      </div>

      <Modal
        show={open}
        onHide={() => {}}
        keyboard={false}
        style={{ border: "none" }}
        centered
        size="sm"
        contentClassName="border-[4px] border-[#D65072] shadow-none rounded-[30px] relative max-w-[280px] mx-auto"
      >
        <div className="absolute -top-[60px] left-0 w-full flex justify-center">
          <img
            src="/images/popup-texture-top.png"
            alt="texture"
            className="w-[90%]"
            style={{
              // Force GPU compositing on Android
              transform: "translate3d(0,0,0)",
              WebkitTransform: "translate3d(0,0,0)",
              willChange: "transform",
            }}
          />
        </div>
        <div className="flex justify-center items-center h-[280px]">
          {!resultData ? (
            // <div className="bg-[#D65072] w-[120px] h-[120px] text-white text-[50px] font-bold flex justify-center items-center rounded-[10px]">
            //   50
            // </div>
            <CardGameItem width={120} height={120} itemKey={"l4card"} />
          ) : (
            imageScratch && (
              <ScratchCard
                width={120}
                height={120}
                image={imageScratch}
                finishPercent={80}
                onComplete={() => {
                  setTimeout(() => {
                    callbackData(resultData);
                  }, 2000);
                }}
              >
                {/* {resultData?.message || "No Data"} */}
                {/* <CardGameItem width={120} height={120} /> */}
                <div className="flex flex-col justify-center items-center">
                  <CardGameItem width={90} height={90} itemKey={"point"} />
                  <div className="text-[20px]">
                    {(
                      resultData?.ticketDoc?.result_lv4?.pointAmount || 0
                    ).toLocaleString()}
                  </div>
                </div>
              </ScratchCard>
            )
          )}
        </div>
        <Modal.Footer
          className="absolute -bottom-[80px] left-0 w-full flex justify-center border-0 bg-transparent"
          hidden={!!resultData}
        >
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={loading}
            className="border-[#ffffff] border-[2px] rounded-[20px] px-8 py-2 font-bold text-lg hover:border-[#ffffff]"
          >
            {"ເປີດສະຫລາກ"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
